import { render, staticRenderFns } from "./ProjectItem.vue?vue&type=template&id=61190760&scoped=true&"
import script from "./ProjectItem.vue?vue&type=script&lang=js&"
export * from "./ProjectItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectItem.vue?vue&type=style&index=0&id=61190760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61190760",
  null
  
)

export default component.exports